export class JobAlertPauseV2{
    jobAlertIds: number[]=[];
    pauseAllJobAlerts:boolean= false;
    companyCode:string= "";
    email:string=""
}
